import {
  Box,
  Card,
  CardContent,
  Grid,
  Paper,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TableBody,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import { useLocation } from "react-router-dom";

const LeaveBalanceDetails = ({ leavebalanceDetails }) => {
  const location = useLocation();

  return (
    <div>
      <Box pb={4}>
        <Grid container spacing={3}>
          <Grid item xs={12} md={4}>
            <Card variant="outlined">
              <CardContent>
                <Typography color="textSecondary" gutterBottom>
                  Leave Balance of this Month
                </Typography>
                <TableContainer component={Paper}>
                  <Table aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell>Leave type</TableCell>
                        <TableCell align="right">Days</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Casual Leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.casual || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Sick Leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.sick || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Privilege leave
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.personal || 0}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell component="th" scope="row">
                          Permissions
                        </TableCell>
                        <TableCell align="right">
                          {leavebalanceDetails?.permission || 0}
                        </TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </CardContent>
            </Card>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

export default LeaveBalanceDetails;
